import React from 'react';
import PlaylistGenerator from '../components/PlaylistGenerator';
import '../styles/global.scss';

const HomePage = () => {
  return (
    <div className="home-page">

      <header className="hero-section">
          <h1>WORLD <br></br> PLAYLIST</h1>
          <p className="hero-subtitle">Learn about the world with music. </p>
      </header>
      
      <main className="main-content">
        <PlaylistGenerator />
      </main>
      
      <footer className="footer">
          <p>©2025 - World Playlist <br /> Data powered by MusicBrainz API</p>
          <p className='author'>Designed and coded by Malena Cané Tomsic</p>
      </footer>
      
      <div className='background-video'>
        <video className='video-wrapper' autoPlay loop muted>
          <source src='/media/background_compressed.mp4' type='video/mp4' />
        </video>
      </div>


    </div>
  );
};

export default HomePage;
